import React from 'react';
import { Info, Briefcase, Building, Phone, Mail } from 'lucide-react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 animated-section">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">About Arrow Drop Foundation (ADF-NGO)</h2>
          <p className="text-lg text-muted-foreground">
            Arrow Drop Foundation, also known as ADF-NGO, is committed to making a positive impact in our community. 
            We are a registered Section 8 Company with License No: 167793 under the Companies Act. 
            Our mission is to create meaningful change and contribute to the betterment of society through 
            comprehensive social development programs.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border flex flex-col items-center text-center animated-section">
            <div className="p-3 rounded-full bg-primary/10 mb-4">
              <Info className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Our Vision</h3>
            <p className="text-muted-foreground">
              Arrow Foundation envisions a society where every individual has the opportunity to thrive 
              and contribute to their community's growth and development through education and skill enhancement.
            </p>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border flex flex-col items-center text-center animated-section">
            <div className="p-3 rounded-full bg-primary/10 mb-4">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Our Approach</h3>
            <p className="text-muted-foreground">
              Drop Foundation takes a collaborative approach, working closely with communities, 
              organizations, and individuals to identify needs and implement sustainable solutions 
              for long-term social impact.
            </p>
          </div>

          <div className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border flex flex-col items-center text-center animated-section">
            <div className="p-3 rounded-full bg-primary/10 mb-4">
              <Building className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Registration Status</h3>
            <p className="text-muted-foreground">
              ADF-NGO is a registered Section 8 Company with License No: 167793 
              under the Companies Act, operating as a non-profit entity with full legal compliance.
            </p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Directors</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/raffilook.png"
                alt="Raffi A - President of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. Raffi. A</h3>
              <p className="text-muted-foreground mb-4">President</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 9698862115</span>
                </div>
                <div className="flex items-center text-muted-foreground">
                  <Mail className="w-5 h-5 mr-2" />
                  <span>Raffi@arrowdropfoundation.com</span>
                </div>
              </div>
            </div>
          </div>    
          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://munversheriff.com/assets/profile-pic.png"
                alt="Munversheriff A - Secretary of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. Munversheriff. A</h3>
              <p className="text-muted-foreground mb-4">Secretary</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 9087306340</span>
                </div>
                <div className="flex items-center text-muted-foreground">
                  <Mail className="w-5 h-5 mr-2" />
                  <span>Munna@arrowdropfoundation.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/ThamaraiSelvam.png"
                alt="Thamarai Selvam T - Treasurer of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr.Thamarai Selvam.T</h3>
              <p className="text-muted-foreground mb-4">Treasurer</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 9629665932</span>
                </div>
                <div className="flex items-center text-muted-foreground">
                  <Mail className="w-5 h-5 mr-2" />
                  <span>selvam@arrowdropfoundation.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
{/* This section is update for members display */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Members</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/manvil.png"
                alt="A.V. Manvil - Member of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. A.V. Manvil</h3>
              <p className="text-muted-foreground mb-4">ADF-NGO-MANVIL</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 81240 85000</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/thangavel.png"
                alt="Thangavel Palaniyappan - Member of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. Thangavel Palaniyappan</h3>
              <p className="text-muted-foreground mb-4">ADF-NGO-THANGAVEL</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 99524 57632</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/karthik.png"
                alt="Karthikeyan K - Member of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. Karthikeyan K M.s.c., Software System.,</h3>
              <p className="text-muted-foreground mb-4">ADF-NGO-KARTHIKEYAN </p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 81486 64035</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section">
            <div className="aspect-[4/4] relative">
              <img 
                src="https://marketstream.in/img/team/sulaiman.png"
                alt="Sulaiman A - Member of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. Sulaiman A</h3>
              <p className="text-muted-foreground mb-4">ADF-NGO-SULAIMAN</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 90257 27885</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Legal Advisor</h2>
        </div>

        <div className="flex justify-center">
          <div className="bg-card rounded-lg overflow-hidden shadow-subtle dark:shadow-subtle-dark border border-border animated-section max-w-sm">
            <div className="aspect-[5/6] relative">
              <img 
                src="https://marketstream.in/img/team/noor.jpg"
                alt="R. Noor Mohammed - Legal Advisor of Arrow Drop Foundation"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-2">Mr. R. Noor Mohammed BA.,LL.B.</h3>
              <p className="text-muted-foreground mb-4">High Court of Madras<br/>Chamber No.298</p>
              <div className="space-y-2">
                <div className="flex items-center text-muted-foreground">
                  <Phone className="w-5 h-5 mr-2" />
                  <span>+91 9344435960</span>
                </div>
                <div className="flex items-center text-muted-foreground">
                  <Mail className="w-5 h-5 mr-2" />
                  <span>legal@arrowdropfoundation.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;